import { render } from "./AnteAtenLOV.vue?vue&type=template&id=31607f46"
import script from "./AnteAtenLOV.vue?vue&type=script&lang=js"
export * from "./AnteAtenLOV.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__